/**
 * The strictly-necessary rows of the cookie policy: where the consent
 * window (InMobi Choice, `src/cookie/inMobiChoice.ts`) keeps your answer —
 * the four cookies it set on a real accept (2026-11-03).
 * Set in every city, because the window runs wherever the site may show
 * ads.
 */
export function ConsentRecordCookies() {
  return (
    <>
      <tr>
        <td>
          <code>euconsent-v2</code>
        </td>
        <td>
          Records your consent choice (IAB TCF consent string), set by our consent platform, InMobi
          Choice.
        </td>
        <td>13 months</td>
      </tr>
      <tr>
        <td>
          <code>addtl_consent</code>
        </td>
        <td>Records your choice for Google&apos;s advertising partners outside IAB TCF.</td>
        <td>13 months</td>
      </tr>
      <tr>
        <td>
          <code>IABGPP_HDR_GppString</code>
        </td>
        <td>Records your choice in the IAB Global Privacy Platform format.</td>
        <td>13 months</td>
      </tr>
      <tr>
        <td>
          <code>usprivacy</code>
        </td>
        <td>Records your US privacy (opt-out) status.</td>
        <td>13 months</td>
      </tr>
    </>
  )
}
